import { CRM } from "@/components/atomic-crm/root/CRM";
import { champConfiguration } from "@/components/atomic-crm/root/champConfiguration";

/**
 * CHAMP Athletics CRM, built on Atomic CRM.
 *
 * Upstream resource names stay as they are in the database and code
 * (companies, contacts, deals, sales). Only the labels change, via
 * providers/commons/champMessages.ts:
 *   companies -> Families, contacts -> People (guardians and players),
 *   deals -> Enrollments, sales -> Staff.
 *
 * Branding, enrollment stages and the other settings live in
 * root/champConfiguration.ts.
 */
const App = () => <CRM {...champConfiguration} />;

export default App;
